import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template"];

  connect() {
    this.index = this.listTarget.querySelectorAll(".knowledge-link-row").length;
  }

  add(event) {
    event.preventDefault();
    const fragment = this.templateTarget.content.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.appendChild(fragment);
    const html = wrapper.innerHTML.replace(/NEW_INDEX/g, this.index);
    this.listTarget.insertAdjacentHTML("beforeend", html);
    this.index++;
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest(".knowledge-link-row");
    if (!row) return;

    const destroyInput = row.querySelector("input[name*='_destroy']");
    if (destroyInput) {
      destroyInput.value = "1";
      row.style.display = "none";
    } else {
      row.remove();
    }
  }
}
